const COMPRAS = '1'
const PAGOS = '2'
const AUTOGESTION = '3'
const MENSAJES = '4'
const REPORTES = '5'
const INSTRUCTIVOS = '6'
const MAESTRO_PROVEEDORES = '7'
const ADMIN_PORTAL = '15'
const ADMIN_SISTEMA = '18'
const PROVEEDOR = '19'
const AUDITORIA = '20'
const ACTIVADOR_USUARIOS = '21'
const ALERTA_MENSAJES = '22'
const AUTORIZADOR_DG = '23'
const AUTORIZADOR_DI = '24'
const AUTORIZADOR_DP = '25'
const AUTORIZADOR_DG_PE = '26'
const AUTORIZADOR_DI_PE = '27'
const AUTORIZADOR_DP_PE = '28'

export default {
  COMPRAS: COMPRAS,
  PAGOS: PAGOS,
  AUTOGESTION: AUTOGESTION,
  MENSAJES: MENSAJES,
  REPORTES: REPORTES,
  INSTRUCTIVOS: INSTRUCTIVOS,
  MAESTRO_PROVEEDORES: MAESTRO_PROVEEDORES,
  ADMIN_PORTAL: ADMIN_PORTAL,
  ADMIN_SISTEMA: ADMIN_SISTEMA,
  PROVEEDOR: PROVEEDOR,
  AUDITORIA: AUDITORIA,
  ACTIVADOR_USUARIOS: ACTIVADOR_USUARIOS,
  ALERTA_MENSAJES: ALERTA_MENSAJES,
  AUTORIZADOR_DG: AUTORIZADOR_DG,
  AUTORIZADOR_DI: AUTORIZADOR_DI,
  AUTORIZADOR_DP: AUTORIZADOR_DP,
  AUTORIZADOR_DG_PE: AUTORIZADOR_DG_PE,
  AUTORIZADOR_DI_PE: AUTORIZADOR_DI_PE,
  AUTORIZADOR_DP_PE: AUTORIZADOR_DP_PE
}



// WEBPACK FOOTER //
// ./src/config/roles.js